import { ajax } from '../index'

/**
 * 搜索二级页 相关接口
 */
export default {
  // 获取search 商品数据
  getSearchResult(dataObj: any) {
    return ajax.get('api', `/api/v1/search/keyword`, dataObj)
  },

  // 获取hot products数据
  getHotProducts(categoryId: string | number) {
    return ajax.get('api', `/api/v1/category/hot-products/${categoryId}`, {})
  },

  // 获取shop 商品数据
  getShopResult(dataObj: any) {
    return ajax.get('api', `/api/v1/search/shop`, dataObj)
  },

  // 获取scheme数据
  getSchemeList(id: string, params: any) {
    return ajax.get('api', `/api/v1/scheme/${id}`, params)
  },

  // 获取面包屑数据
  getSchemeBreadcrumb(id: string) {
    return ajax.get('api', `/api/v1/breadcrumb/scheme/${id}`, {})
  },

  // 获取侧边栏数据
  getSchemeSidebar(id: string) {
    return ajax.get('api', `/api/v1/sidebar/filter/scheme?schemeID=${id}`, {})
  },
}